export class DtoPersonamast {
    persona: number;
    busqueda: string;
    esCliente: string;
    esProveedor: string;
    esEmpleado: string;
    esOtro: string;
    documento: string;
    personaAnt: number;
    documentoFiscal: string;
    documentoIdentidad: string;
    estado: string;
    telefono: string;
    direccion: string;
    suspensionFlag: string;

    nombreCompleto: string;
    numeroDiasCobranza: number;
    formadePago: string;
    tipoServicio: string;
    nacionalidad: string;

    vendedor: number;
    conceptoFacturacion: string;
    tipoVenta: string;
    tipoFacturacion: string;
    centroCosto: string;
    formaFacturacion: string;
    rutaDespacho: string;
    personaContacto: string;
    iv_action: string;
    conVencidos: any;

    conAceptada:string;
    desde:Date;
    hasta:Date;
    accion:string;
 
    
}
